import { useEffect, useState } from "react";
import { AppointmentsApi } from "../../../Api/AppointmentsApi";
import { AppointmentsAvailabilityDto } from "@apiModels/AppointmentsAvailabilityDto.csharp";
import { InsuranceServiceDto } from "@apiModels/Insurance/InsuranceServiceDto.csharp";

const api = new AppointmentsApi();

export const useAppointments = (service: InsuranceServiceDto | null) => {
  const [appointments, setAppointments] = useState<
    AppointmentsAvailabilityDto[]
  >([]);
  const [isLoading, setIsLoading] = useState(false);
  const [price, setPrice] = useState<number>();

  useEffect(() => {
    if (!service) return;
    loadAppointmentsData();
  }, [service]);

  const loadAppointmentsData = async () => {
    setIsLoading(true);
    try {
      const response = await api.getFirstAvailable(service!.id);
      setAppointments(response.appointmentsAvailability);
      setPrice(response.price);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    appointments,
    price,
  };
};
